module.exports = __webpack_public_path__ + "img/4c68242e149d7988009640963fcf295f.png";